export const firebaseConfig = {
  apiKey: "AIzaSyCEcKke8k3gQL9N0zsLhTRKV_Wstq17UO4",
  authDomain: "bazar-niketon-assignment.firebaseapp.com",
  projectId: "bazar-niketon-assignment",
  storageBucket: "bazar-niketon-assignment.appspot.com",
  messagingSenderId: "776458501446",
  appId: "1:776458501446:web:6a056075b6c0f24b693947",
};
